import classNames from 'classnames';
import React, { ReactElement, ReactNode } from 'react';

import './styles.less';

type PageHeaderPusherLegacyProps = {
  children: ReactNode;
  /** @deprecated Use `ds` with `padded={false}`. */
  noPadding?: boolean;
  /**
   * @deprecated Use `ds` with `enterpriseScoped={false}` when padded.
   * Remove padding used for providing space for Intercom widget.
  */
  noIntercomPadding?: boolean;
  // ----------
  /** Aligned with design system page rhythm */
  ds?: never;
  padded?: never;
  enterpriseScoped?: never;
};

type PageHeaderPusherProps = {
  /** Aligned with design system page rhythm */
  ds: true;
  children: ReactNode;
  padded?: boolean;
  /** Takes care of MobileNavBar and Intercom clearance when `padded` is true. */
  enterpriseScoped?: boolean;
  // ----------
  noPadding?: never;
  noIntercomPadding?: never;
};

type Props = PageHeaderPusherLegacyProps | PageHeaderPusherProps;

/**
 * Scroll shell beneath a fixed page header.
 *
 * Legacy path: `noPadding` / `noIntercomPadding` (deprecated).
 * Design-system path: `ds` — `padded` and `enterpriseScoped` default to true.
 */
function PageHeaderPusher(props: Props): ReactElement {
  const { children } = props;

  if (props.ds) {
    const padded = props.padded ?? true;
    const enterpriseScoped = props.enterpriseScoped ?? true;

    return (
      <div
        className={classNames('PageHeaderPusher', {
          'PageHeaderPusher--no-bottom-nav': !enterpriseScoped
        })}
      >
        <div
          className={classNames('PageHeaderPusher-ds-inner', {
            'PageHeaderPusher-ds-inner--padded-enterprise': padded && enterpriseScoped,
            'PageHeaderPusher-ds-inner--padded-non-enterprise': padded && !enterpriseScoped
          })}
        >
          {children}
        </div>
      </div>
    );
  }

  const { noPadding, noIntercomPadding } = props;

  return (
    <div className="PageHeaderPusher">
      <div
        className={classNames('PageHeaderPusher-inner', {
          'no-padding': noPadding,
          'no-intercom-padding': noIntercomPadding
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default PageHeaderPusher;
